import React, { useState } from 'react';
import { Landmark, TrendingUp, ArrowLeftRight, ShieldAlert, History, ShieldCheck } from 'lucide-react';
import BankAccountPage from './BankAccountPage';
import RevenueEconomyPage from './RevenueEconomyPage';
import OperationsPage from './OperationsPage';
import ApprovalCenterAdminPage from './ApprovalCenterAdminPage';
import HistoryPage from './HistoryPage';
import AuditPage from './AuditPage';

function Center({ eyebrow, title, description, tabs, defaultTab }) {
  const [active, setActive] = useState(defaultTab || tabs[0].id);
  const selected = tabs.find(tab => tab.id === active) || tabs[0];
  return <div className="space-y-5 fade-up" dir="rtl">
    <header className="border-b border-[var(--c-border)] pb-4">
      <p className="text-xs font-bold tracking-[0.18em] text-[var(--c-gold)]">{eyebrow}</p>
      <h1 className="section-title mt-2 text-3xl">{title}</h1>
      <p className="mt-2 text-sm text-[var(--c-muted)]">{description}</p>
    </header>
    <nav className="flex gap-2 overflow-x-auto rounded-2xl border border-[var(--c-border)] bg-white p-2" aria-label={title}>
      {tabs.map(tab => { const Icon = tab.icon; return <button key={tab.id} onClick={() => setActive(tab.id)} className={`flex min-h-11 shrink-0 items-center gap-2 rounded-xl px-4 text-xs font-bold ${active === tab.id ? 'bg-[var(--color-navigation)] text-white shadow-sm' : 'text-[var(--c-muted)] hover:bg-slate-50'}`}><Icon className="h-4 w-4" />{tab.label}</button>; })}
    </nav>
    <div>{selected.content}</div>
  </div>;
}

export function BankFundsSection() {
  return <Center eyebrow="BANK FUNDS" title="أموال البنك" description="موارد بنك العائلة المملوكة له: الحساب الداخلي والإيرادات وسجل مصادرها. لا توجد طلبات مستخدمين هنا." tabs={[
    { id: 'overview', label: 'الحساب الداخلي', icon: Landmark, content: <BankAccountPage /> },
    { id: 'revenue', label: 'الإيرادات', icon: TrendingUp, content: <RevenueEconomyPage /> },
  ]} />;
}

export function OperationsApprovalsSection() {
  return <Center eyebrow="OPERATIONS & APPROVALS" title="العمليات والموافقات" description="طلبات العمليات المصرفية، حالاتها، والموافقات. أرصدة وإيرادات البنك المملوكة له تبقى في أموال البنك." tabs={[
    { id: 'operations', label: 'العمليات', icon: ArrowLeftRight, content: <OperationsPage /> },
    { id: 'approvals', label: 'الموافقات', icon: ShieldAlert, content: <ApprovalCenterAdminPage /> }
  ]} />;
}

export function LogsCenter() {
  return <Center eyebrow="LOGS CENTER" title="مركز السجلات" description="المعاملات المالية وسجل تدقيق الإدارة في مكان واحد، مع بقائهما مفصولين وظيفياً." tabs={[
    { id: 'transactions', label: 'المعاملات', icon: History, content: <HistoryPage /> },
    { id: 'audit', label: 'سجل التدقيق', icon: ShieldCheck, content: <AuditPage /> }
  ]} />;
}
